import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';

//= ========================================================================

const MyTableHeader = ({ width, arrTitles, onCellPressed }) => {
  const renderHeader = () => arrTitles.map((item, index) => {
    if (item === 'Status') {
      return (
        <View
          style={{
            width: 80,
            height: 30,
            justifyContent: 'center',
            backgroundColor: '#fff',
          }}
          key="status"
        >
          <View
            style={{
              marginLeft: 0,
              height: 30,
              width: 1,
              backgroundColor: '#001a2f',
              position: 'absolute',
            }}
          />
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            style={{
              textAlign: 'center',
              fontFamily: 'Rubik-Medium',
              fontSize: 14,
              color: '#001a2f',
            }}
          >
            {item}
          </Text>
        </View>
      );
    }

    return (
      <TouchableOpacity
        style={{
          flex: 1,
          height: 30,
          justifyContent: 'center',
          backgroundColor: '#fff',
        }}
        key={item}
        onPress={() => {
          onCellPressed(index);
        }}
      >
        {index === 0 ? null : (
          <View
            style={{
              marginLeft: 0,
              height: 30,
              width: 1,
              backgroundColor: '#001a2f',
              position: 'absolute',
            }}
          />
        )}

        <Text
          numberOfLines={1}
          ellipsizeMode="tail"
          style={{
            textAlign: 'center',
            fontFamily: 'Rubik-Medium',
            fontSize: 14,
            color: '#001a2f',
          }}
        >
          {item}
        </Text>
      </TouchableOpacity>
    );
  });

  //-------------------------------------------------------------------------------

  return (
    <View
      style={{
        width,
        height: 32,
        marginTop: 0,
        marginLeft: 0,
        backgroundColor: '#001a2f',
      }}
    >
      <View
        style={{
          width: width - 2,
          height: 30,
          marginTop: 1,
          marginLeft: 1,
          backgroundColor: '#fff',
          flexDirection: 'row',
        }}
      >
        {renderHeader()}

        <View
          style={{
            width: 190 - 60,
            height: 30,
            justifyContent: 'center',
            backgroundColor: '#fff',
          }}
          key="actions"
        >
          <View
            style={{
              marginLeft: 0,
              height: 30,
              width: 1,
              backgroundColor: '#001a2f',
              position: 'absolute',
            }}
          />
        </View>
      </View>
    </View>
  );
};

export default MyTableHeader;
